"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var types_1 = require("../types");
var useSoldBanner = function (_a) {
    var sold = _a.sold, stcStatus = _a.stcStatus, winningBidAmount = _a.winningBidAmount, isReserveMet = _a.isReserveMet, timerStatus = _a.timerStatus, _b = _a.shortBanner, shortBanner = _b === void 0 ? false : _b;
    var soldBanner = (0, react_1.useMemo)(function () {
        var banner = {
            showBanner: false,
            bannerText: "",
        };
        var hasWinningBid = !!winningBidAmount;
        if (sold) {
            banner.showBanner = true;
            banner.bannerText = "SOLD";
        }
        else if (timerStatus === types_1.LotStatus.COMPLETED && hasWinningBid) {
            if (stcStatus === 1) {
                banner.showBanner = true;
                banner.bannerText = shortBanner ? "SOLD STC" : "SOLD SUBJECT TO CONFIRMATION";
            }
            else if (isReserveMet) {
                banner.showBanner = true;
                banner.bannerText = "SOLD";
            }
        }
        return banner;
    }, [isReserveMet, shortBanner, sold, stcStatus, timerStatus, winningBidAmount]);
    return soldBanner;
};
exports.default = useSoldBanner;
